export const environment = {
  production: true,
  serverEnv: 'edge',
  rollbar: {
    enabled: true
  }
};
